/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";
import { useIcon, objectFilter } from "Utils";

/**
 * ProjectPreview Component
 */
function ProjectPreview(props) {
  const { previewFileUid, timestamp } = props;

  const previewImg = useIcon(previewFileUid, timestamp)
  const imgProps = objectFilter(props, ["className", "style"]);

  if (previewImg) {
    return <img src={previewImg} alt="" {...imgProps} />;
  } else return null;
}

/**
 * Export component
 */
// map redux state to props
export default connect((state, ownProps) => {
  let { projectUid } = ownProps;
  let { previewFileUid } = state.list.project[projectUid] || {};
  let { timestamp } = state.list.file[previewFileUid] || {}
  return {
    previewFileUid,
    timestamp
  };
})(ProjectPreview);
